"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Keyboard = _interopRequireDefault(require("../Keyboard"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var dropKeyFrames = (0, _styledComponents.keyframes)(["0%{opacity:0.5;transform:scale(0.8);}100%{opacity:1;transform:scale(1);}"]);

var D = _styledComponents["default"].div.withConfig({
  displayName: "Drop__D",
  componentId: "sc-45kiok-0"
})(["box-sizing:border-box;border:", " solid ", ";position:absolute;width:100%;background-color:", ";border-top:0px;outline:none;z-index:20;opacity:0;transform-origin:top left;animation:", " 0.1s forwards;animation-delay:0.01s;"], function (props) {
  return props.theme.drop.border.width;
}, function (props) {
  return props.theme.drop.border.color;
}, function (props) {
  return props.theme.drop.backgroundColor;
}, dropKeyFrames);

var Drop = function Drop(props) {
  var dropRef = (0, _react.useRef)(null);

  var onEsc = function onEsc(event) {
    var onEscExternal = props.onEsc;
    event.stopPropagation();

    if (onEscExternal) {
      onEscExternal(event);
    }
  };

  var onClickDocument = function onClickDocument(event) {
    var dropTarget = props.target,
        onClickOutside = props.onClickOutside;
    var dropTargetNode = dropTarget;
    var dropNode = dropRef.current;

    if (onClickOutside && dropNode // need this for ie11
    && !dropTargetNode.contains(event.target) && !dropNode.contains(event.target)) {
      onClickOutside();
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', onClickDocument);
    return function () {
      document.removeEventListener('mousedown', onClickDocument);
    };
  }, []);

  var onEscExternal = props.onEsc,
      onKeyDown = props.onKeyDown,
      rest = _objectWithoutProperties(props, ["onEsc", "onKeyDown"]); // prevent react warning


  delete rest.onClickOutside;
  return /*#__PURE__*/_react["default"].createElement(_Keyboard["default"], {
    onEsc: onEscExternal && onEsc,
    onKeyDown: onKeyDown,
    target: "document"
  }, /*#__PURE__*/_react["default"].createElement(D, _extends({
    ref: dropRef
  }, rest)));
};

var _default = Drop;
exports["default"] = _default;